<template>
	<v-card>
		<SubBiddersTable :read-only="true"/>
	</v-card>
</template>

<script>
  import SubBiddersTable from "@/view/logged/subbidders/components/SubBiddersTable";

  export default {
    name: "EmployeeSubBiddersView",

    components: {SubBiddersTable},
  };
</script>

<style scoped>

</style>